import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { SensorType } from '../types/sensor-type';
import { FormGroupValue } from '../../../ui/gzForm/formGroup/types/form-group-value';
import { Observable } from 'rxjs';
import { BaseSensorWebController } from './controller/BaseSensorWebController';

export abstract class BaseSensorWebComponent extends BaseWebComponentElement {
  public controller!: BaseSensorWebController;
  protected sensorType: SensorType;
  protected composedSensors: SensorType[] = [];
  private sensorId: string;
  private isConfigured = false;
  public hasDetails = false;
  protected sensors: any = [];
  public isOptional = false;
  public isComposed = false;
  public formNeedToBeEmptyForAddedSensor = false;

  isEnabled(): boolean {
    return this.controller.isSensorEnabled();
  }

  public getSensorType(): SensorType {
    return this.sensorType;
  }

  public setSensors(sensors: any): void {
    this.sensors = sensors;
  }

  public getSensors(): void {
    return this.sensors;
  }

  public getComposedSensors(): SensorType[] {
    return this.composedSensors;
  }

  public setIsConfigured(isConfigured: boolean): void {
    this.isConfigured = isConfigured;
  }

  public getIsConfigured(): boolean {
    return this.isConfigured;
  }

  public setEnabled(isEnabled: boolean): void {
    this.controller.setEnabledAllFields(isEnabled);
  }

  public setSensorId(id): void {
    this.sensorId = id;
  }

  public getSensorId(): string {
    return this.sensorId;
  }

  public getValue(): FormGroupValue {
    return this.controller.view.formGroup
      ? this.controller.view.formGroup.getValueRecursively(this.controller.view.formGroup, true)
      : {};
  }

  public getSpecifics(): FormGroupValue {
    return {};
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.formGroup.valid$;
  }

  public get valid(): boolean {
    if (!this.controller.view.formGroup) {
      return false;
    }
    return this.controller.view.formGroup.valid;
  }

  public resetData(): void {
    this.controller.resetData();
  }

  public setValues(values: FormGroupValue, force: boolean = false): void {
    if (!this.isEnabled() && !force) {
      return;
    }
    this.controller.setDataInForm(values);
  }

  public getDetails(): any[] {
    return [];
  }
}
